import { useState } from 'react';

import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import Collapse from '@mui/material/Collapse';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

import { ItemInterface, MenuItemInterface } from '..';

interface CollapseMenuProps {
  item: ItemInterface;
  navigateToRoute(str: string | null): void;
}

export const CollapseMenu = ({ item, navigateToRoute }: CollapseMenuProps) => {
  const [open, setOpen] = useState(false);

  const handleClick = () => {
    setOpen(!open);
  };

  if (!item?.children) return null;

  const children: MenuItemInterface = item?.children;

  return (
    <>
      <ListItemButton onClick={handleClick}>
        <ListItemIcon>{item.leftIcon}</ListItemIcon>
        <ListItemText primary={item.label} />
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {Object.keys(children).map((key) => (
            <ListItemButton key={key} sx={{ pl: 4 }} onClick={() => navigateToRoute(children[key].to as string | null)}>
              <ListItemIcon>{children[key].leftIcon}</ListItemIcon>
              <ListItemText primary={children[key].label} />
            </ListItemButton>
          ))}
        </List>
      </Collapse>
    </>
  );
};
